import { useState, useEffect } from "react";
import { fetchFinanciaciones } from "./firestoreRest";

const useFinanciaciones = () => {
  const [financiaciones, setFinanciaciones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let idleId;
    let timeoutId;

    const fetchData = async () => {
      try {
        const datos = await fetchFinanciaciones();
        if (!cancelled) setFinanciaciones(datos);
      } catch {
        if (!cancelled) setFinanciaciones([]);
      }
      if (!cancelled) setLoading(false);
    };

    const scheduleFetch = () => {
      if (cancelled) return;
      fetchData();
    };

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      idleId = window.requestIdleCallback(scheduleFetch, { timeout: 3000 });
    } else {
      timeoutId = window.setTimeout(scheduleFetch, 500);
    }

    return () => {
      cancelled = true;
      if (idleId && "cancelIdleCallback" in window) {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, []);

  return { financiaciones, loading };
};

export default useFinanciaciones;
